import { Component } from '@verndale/core';

class ProductSampleSelection extends Component {
  constructor(el, props) {
    super(el);
    this.filters = props.Filters;
    this.tableAttributes = props.TableAttributes;
    this.skus = props.Skus;
    this.originalSkus = props.Skus;
    this.displayNextFilter();
    this.clicked = 0;
    this.clickedValue = '';
  }

  setupDefaults() {
    this.dom = {
      sampleSelection: this.el.querySelector(
        '.product-detail__sample-selection'
      ),
      noSampleMessage: this.el.dataset.noSampleMessage,
      addToBasketLabel: this.el.dataset.addToBasketLabel,
      skuTerms: this.el.dataset.skuTerms,
    };

    this.selectionIndex = 0;
    this.showedQuestions = 0;
    this.filters = {};
    this.tableAttributes = [];
    this.skus = [];
  }

  addListeners() {
    this.el.addEventListener('change', (event) => {
      if (event.target.type === 'radio') {
        this.handleOptionSelect(event.target);
      }
    });
  }

  handleOptionSelect(target) {
    const selectionIndex = this.filters.findIndex(
      (filter) => filter.SKUPropertyName === target.name
    );
    if (this.selectionIndex > selectionIndex) {
      this.selectionIndex = selectionIndex;

      // Remove all filters after the current selection
      const sections = this.el.querySelectorAll(
        '.product-detail__sample-selection-section'
      );
      sections.forEach((section, index) => {
        if (index > selectionIndex) {
          section.remove();
        }
      });
    }

    this.selectionIndex++;
    this.displayNextFilter();
  }

  displayNextFilter() {
    const nextFilter = this.filters[this.selectionIndex];
    if (nextFilter) {
      // Get all values for nextFilter in the this.skus array without duplicating
      let skus = this.skus;

      this.filters.forEach((filter) => {
        // Get value for filter
        const selectedFilter = this.el.querySelector(
          `input[name="${filter.SKUPropertyName}"]:checked`
        );
        // check here after the first filter
        if (selectedFilter) {
          skus = skus.filter((sku) => sku[filter.SKUPropertyValue] === selectedFilter.value);
        }
      });
      const valuesArray = skus.map((sku) => sku[nextFilter.SKUPropertyValue]);
      const idsArray = skus.map((sku) => sku.ID);
      const labelsArray = skus.map((sku) => sku[nextFilter.SKUPropertyName]);

      const values = valuesArray.filter(
        (value, index, self) => self.indexOf(value) === index
      );
      const labels = labelsArray.filter(
        (value, index, self) => self.indexOf(value) === index
      );
      const ids = idsArray.filter(
        (value, index, self) => self.indexOf(value) === index
      );

      if (values.length > 1) {
        // Display the filter
        if (this.clickedValue !== '') {
          this.displayFilter(nextFilter, values, labels, ids);
        }
      } else {
        // Add the hidden filter and skip to the next filter
        this.selectionIndex++;
        this.displayHiddenFilter(nextFilter, values[0]);
        this.displayNextFilter();
      }
    } else {
      // Display results table
      this.displayResultsTable();
    }
  }

  displayFilter(filter, values, labels, ids) {
    const section = document.createElement('div');
    section.classList.add('product-detail__sample-selection-section');
    const filterValues = values
      .map(
        (value, i) =>
          value &&
          `<label><input type='radio' name='${
            filter.SKUPropertyName
          }' value='${value}' data-sku-id='${ids.find((id) =>
            this.skus.find(
              (sku) => sku.ID === id && sku[filter.SKUPropertyValue] === value
            )
          )}'/>
            <span>${labels[i].split('<br>').join(' ')}</span>
          </label>`
      )
      .join('');

    section.innerHTML = `
        <h2 class='product-detail__sample-selection-heading'>${this.showedQuestions < 1 ? this.el.dataset.forAFreeSample.concat(' ') : ''}${filter.Text}</h2>
        <div class='product-detail__sample-selection-options'>
          ${filterValues}
        </div>`;

    this.showedQuestions++;

    this.el.appendChild(section);
    const inputs = section.querySelectorAll('.product-detail__sample-selection-options input');

    inputs.forEach((input) => {
      input.addEventListener('click', (event) => {
        if (this.clickedValue !== '' && this.clickedValue !== event.target.value) {
          const previousInput = section.querySelector(`input[value="${this.clickedValue}"]`);
          if (previousInput) {
            previousInput.checked = false;
          }
          this.clickedValue = event.target.value;
          this.clicked = 0;
        }

        if (this.clicked === 0) {
          event.target.checked = true;
          this.clickedValue = event.target.value;
          this.clicked++;
        } else {
          const element = this.el.querySelector(
            `[value="${this.clickedValue}"][data-sku-id="${event.target.dataset.skuId}"]`
          );
          const closestParent = this.getClosestParent(
            element,
            '.product-detail__sample-selection-section'
          );

          const lastSibling = closestParent.parentNode.lastChild;

          if (lastSibling) {
            lastSibling.remove();
          }
          event.target.checked = false;
          this.clickedValue = '';
          this.clicked = 0;
        }
      });
    });
    this.skus = this.originalSkus;
  }

  getClosestParent(element, selector) {
    let currentElement = element;

    while(currentElement) {
      if (currentElement.matches(selector)) {
        return currentElement;
      }
      currentElement = currentElement.parentNode;
    }
    return null;
  }

  displayHiddenFilter(filter, value) {
    const section = document.createElement('div');
    section.classList.add('product-detail__sample-selection-section');
    section.setAttribute('hidden', '');

    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = filter.SKUPropertyName;
    input.value = value;
    section.appendChild(input);
    this.el.appendChild(section);
  }

  displayResultsTable() {
    // Get the selected sku
    let sku = this.skus[0];
    if (sku) {
      const selectedValues = [];
      const selectedSkuIds = [];
      this.filters.forEach((filter) => {
        const selectedFilter = this.el.querySelector(
          `input[name="${filter.SKUPropertyName}"]:checked`
        );

        if (selectedFilter) {
          selectedValues.push(selectedFilter.value);
          selectedSkuIds.push(selectedFilter.dataset.skuId);
        }
      });

      if (selectedSkuIds.length > 0) {
        sku = Object.values(this.skus)
          .filter((skuValue) => {
            return selectedSkuIds.includes(skuValue.ID);
          })
          .filter((_, i, self) => {
            return i === self.length - 1;
          })[0];
      }

      const section = document.createElement('div');
      section.classList.add('product-detail__sample-selection-section');
      section.innerHTML = `
      ${sku.CanSample ? `<h2 class='product-detail__sample-selection-heading'>${this.el.dataset.tableHeading}</h2>` : ''}
      <table class='product-detail__sample-selection-table'>
          ${this.tableAttributes.map((attribute) => `
          <tr>
            <th>${attribute.Label}</th>
            <td>${sku[attribute.SKUPropertyName]}</td>
          </tr>`).join('')}
      </table>
      ${this.dom.skuTerms ? `<p class='product-detail__sample-selection-message'>${this.dom.skuTerms}</p>` : ''}
      ${sku.CanSample ? `<button class='product-detail__cta' data-id='${sku.ID}'>${this.dom.addToBasketLabel}</button>` : `<p class='product-detail__sample-selection-message'>${this.dom.noSampleMessage}</p>`}
    `;


      const button = section.querySelector('.product-detail__cta');
      if (button) {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          window.addProduct(e.target.dataset.id);
        });
      }

      this.el.appendChild(section);

    }
  }
}

export default ProductSampleSelection;
